import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { jobDetailsJobsConfig } from './config';

const JobDetailsJobStack = createStackNavigator();

const JobDetailsJobNavigator = () => {
  return (
    <JobDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobDetailsJobsConfig.map(({ Component, name }) => (
        <JobDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsJobStack.Navigator>
  );
};

export { JobDetailsJobNavigator };
